import React, { useState, useContext, useCallback, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import MapContext from "../MapContext";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { PlotTrimbleData } from "../GPS/gpsUtil";

const GPSTrimble = () => {
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const { map } = useContext(MapContext);
    const [socketUrl, setSocketUrl] = useState("ws://192.168.0.71:9635");
    const [messageHistory, setMessageHistory] = useState([]);
    const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl);
    useEffect(() => {
        if (!mapConfig) {
        } else {
            console.log(mapConfig.EditLayers);
        }
    }, [mapConfig]);

    useEffect(() => {
        if (lastMessage !== null) {
            setMessageHistory((prev) => prev.concat(lastMessage));
            console.log(JSON.parse(lastMessage.data));
            PlotTrimbleData(map, JSON.parse(lastMessage.data));
        }
    }, [lastMessage, setMessageHistory]);
    const connectionStatus = {
        [ReadyState.CONNECTING]: "Connecting",
        [ReadyState.OPEN]: "Open",
        [ReadyState.CLOSING]: "Closing",
        [ReadyState.CLOSED]: "Closed",
        [ReadyState.UNINSTANTIATED]: "Uninstantiated",
    }[readyState];

    return <></>;
};
export default GPSTrimble;
